import { inject } from '@angular/core';
import { CanMatchFn, Router } from '@angular/router';
import { AuthStoreService } from '@root/app/core/auth/auth-store.service';
import { AppRouteService } from '@shared/services/app-route.service';
import { map, of } from 'rxjs';

export const contractorsPortalLoginGuard = (): CanMatchFn => () => {
  const authStoreService = inject(AuthStoreService);
  const router = inject(Router);

  return of(authStoreService.$isAuthenticated()).pipe(
    map((isAuth) =>
      isAuth ? router.createUrlTree([AppRouteService.homePath()]) : true
    )
  );
};
